import React, { useLayoutEffect, useState, Fragment, useEffect, use } from 'react'
import ReactDOM from "react-dom/client";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, SelectBox, CheckBox } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import { PaymentRequestService } from '../../../apis/apiServices/PaymentRequest';
import { FundRequestService } from '../../../apis/apiServices/FundRequest';
import { Loader } from '../../Shared/PageLoader';
import Swal from 'sweetalert2';
import DataGrid, {
    Column, Editing, Summary, TotalItem,
} from "devextreme-react/data-grid";
import Popup from "devextreme-react/popup";


export default function ViewPaymentRequestComponent() {
    const user = useSelector((state) => state.user.data);
    const location = useLocation();
    const navigate = useNavigate();
    debugger
    const { paymentRequestId, IsShowButtons, isEditAmt } = location.state || {};
    useLayoutEffect(() => {
        const initialize = async () => {
            document.querySelector("#pageTitle").innerHTML = "PR - Payment Request";
            await getPaymentRequestData(paymentRequestId);
            getAttachmentsByRequestIdAndRequestTypeId(paymentRequestId, 3)
        };

        initialize();
    }, []);
    const [loading, setLoading] = useState(false)
    const [paymentRequestData, setPaymentRequestData] = useState(null);
    const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [prAttachmentData, setPRAttachmentData] = useState(null);
    const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);
    const [remarks, setRemarks] = useState(null);
    const [charCount, setCharCount] = useState(0);
    const [error, setError] = useState({});
    const [files, setFiles] = useState([]);

    const getPaymentRequestData = async () => {
        try {
            let body = { 'paymentRequestId': paymentRequestId, 'userId': user?.userId }
            const response = await PaymentRequestService.getPaymentRequestDetailsByPRId(body)
            setPaymentRequestData(response?.data);
        } catch (error) {
            console.log("Error getPaymentRequestData===>", error);
        }
    }

    const handleAproveRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleApproveSubmit = async () => {
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        } else {
            setError({ remarks: "", userIdForRejectIOM: "" });
        }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }


        setIsModalVisible(false);
        setRemarks("");
        setError({});
        let body = {
            modifiedBy: user.userId || 0,
            paymentRequestId: paymentRequestData?.paymentRequestId,
            serialNo: paymentRequestData?.serialNo,
            remarks: remarks || "",
            stageIndex: paymentRequestData?.currentStageIndex,
            items: (paymentRequestData?.items || []).map(item => ({
                itemId: item.itemId || item.id,  // adjust if your object uses `id` instead of `itemId`
                itemSerialNo: item.itemSerialNo || '',
                paidAmt: item.paidAmt || 0
            }))
        };
        setLoading(true)
        const response = await PaymentRequestService.approvePaymentRequest(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })

            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (location?.state?.fromPendingPage === true) {
                navigate(-1);
                //console.log("reduxcount", iomPendingCount);
            } else {
                navigate(-1);
            }
        });
    };

    const handleRejectRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleRejectSubmit = async () => {
        //e.preventDefault();
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        }

        // if (!userIdForRejectIOM) {
        //     newError.userIdForRejectIOM = "Please select user";
        // }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        // No errors, proceed
        setIsRejectModalVisible(false);
        setRemarks("");
        //setUserIdForRejectIOM(null);
        setError({});


        let body = {
            modifiedBy: user.userId,
            paymentRequestId: paymentRequestData?.paymentRequestId,
            serialNo: paymentRequestData?.serialNo,
            remarks: remarks || "",
            backToStageIndex: 1,
        };
        setLoading(true)
        const response = await PaymentRequestService.rejectPaymentRequest(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            navigate(-1)
        });
    };

    const getAttachmentsByRequestIdAndRequestTypeId = async (requestId, requestTypeId) => {
        try {
            const response = await FundRequestService.getRequestAttachmentsByRequestId(requestId, requestTypeId)
            setPRAttachmentData(response?.data);
        } catch (error) {
            console.log("Error getAttachmentsByRequestIdAndRequestTypeId===>", error);
        }
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e?.target?.files); // Convert FileList to Array
        setFiles(prevState => [...prevState, ...selectedFiles]);
    };

    const handleFileRemove = (index) => {
        let attachmentToRemove = files?.find((_, i) => i === index)

        setFiles((prev) => prev?.filter((_, i) => i !== index));

        if (attachmentToRemove?.attachmentId) {
            setRemovedAttachmentIds(prevState => {
                let previousIds = prevState || [];
                return [
                    ...previousIds,
                    attachmentToRemove?.attachmentId || 0
                ]
            });
        }
    };

    const deleteFundRequestItem = async (rowData) => { }
    //console.log("paymentRequestData", paymentRequestData)
    return (
        <Fragment>
            <div className="content">
                <div className='card top-bottom' >
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-8 col-md-6 col-sm-12'>
                                {IsShowButtons &&
                                    <>
                                        {paymentRequestData?.requestStatusId !== 15 &&
                                            <Button
                                                text={paymentRequestData?.nextStageActionType ? paymentRequestData?.nextStageActionType : "Send for Approval"}
                                                icon="check"
                                                onClick={() => {
                                                    // ✅ Validate if any item has paidAmt = 0
                                                    const hasZeroPaidAmt = (paymentRequestData?.items || []).some(
                                                        (item) => Number(item.paidAmt) === 0
                                                    );

                                                    if (hasZeroPaidAmt) {
                                                        Swal.fire(
                                                            "Amount Limit Warning!",
                                                            "Payment amount cannot be 0 for any vendor.",
                                                            "warning"
                                                        );
                                                        return;
                                                    }

                                                    // 🔹 Validation: Check if any paidAmt > recommendedAmt
                                                    const hasOverpaidItem = paymentRequestData?.items.some(
                                                        item => Number(item.paidAmt) > Number(item.recommendedAmt)
                                                    );

                                                    if (hasOverpaidItem) {
                                                        Swal.fire(
                                                            "Amount Limit Warning!",
                                                            "Payment amount cannot be greater than the recommended amount for any item.",
                                                            "warning"
                                                        );
                                                        return;
                                                    }

                                                    setIsModalVisible(true);
                                                }}
                                                visible={paymentRequestData?.currentUserId === user?.userId && paymentRequestData?.isApproved === false}
                                                stylingMode="default"
                                                type="success"
                                                className="mr-2"
                                            />
                                        }


                                        {(paymentRequestData?.requestStatusId !== 8 && paymentRequestData?.requestStatusId !== 15 && paymentRequestData?.requestStatusId !== 4) &&
                                            <Button
                                                text="Back to Draft"
                                                icon="back"
                                                visible={paymentRequestData?.createdByUserId !== user?.userId && paymentRequestData?.currentUserId === user?.userId && paymentRequestData?.isApproved === false}
                                                onClick={async () => {
                                                    // if (iomData?.reviewerStatusId === 10) {
                                                    //     Swal.fire({
                                                    //         icon: 'info',
                                                    //         title: 'Pending for Review',
                                                    //         text: 'This IOM is still pending for review.',
                                                    //     });
                                                    //     return; // stop here so it doesn't go to confirm dialog
                                                    // }

                                                    const confirmResult = await Swal.fire({
                                                        title: "Are you sure?",
                                                        text: "Do you want to send the Payment Request back to draft?",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Yes, continue",
                                                        cancelButtonText: "No, cancel"
                                                    });

                                                    if (confirmResult.isConfirmed) {
                                                        setIsRejectModalVisible(true);
                                                    }
                                                }}
                                                stylingMode="default"
                                                type="danger"
                                                className="mr-2"
                                                hint="Back to Draft"
                                            />}
                                    </>
                                }
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 text-right'>
                                <Button
                                    text="Back"
                                    icon="back"
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='Back'
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className={'col-lg-9 col-md-6'}>
                        <div className='card' >
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="hugeicons:file-02" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Request No.</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.serialNo}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:date-range-outline-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Created On</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.createdOn}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Site</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.projectName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Department</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.departmentName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="tabler:category-2" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Category</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.categoryName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-6 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:subject-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Subject</div>
                                                    <div className='fieldvalue'>{paymentRequestData?.subject}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card' >
                            <div className='card-body'>
                                <DataGrid
                                    dataSource={paymentRequestData?.items || []}
                                    columnAutoWidth
                                    showBorders
                                    showRowLines
                                    showColumnLines={false}
                                    noDataText="No details"
                                    className='selectable-grid'
                                    onCellValueChanged={(e) => {
                                        if (e.column.dataField === "paidAmt") {
                                            // update your state when payment amount changes
                                            const updatedItems = paymentRequestData?.items?.map(item =>
                                                item.id === e.key ? { ...item, paymentAmt: e.value } : item
                                            );
                                            setPaymentRequestData(prev => ({ ...prev, items: updatedItems }));
                                        }
                                    }}
                                >
                                    {/* enable editing */}
                                    <Editing mode="cell" allowUpdating={true} />
                                    {/* <Selection mode="multiple" showCheckBoxesMode="always" /> */}
                                    {/* <Column
                                        caption=""
                                        width={50}
                                        cellRender={({ data }) => {
                                            return (
                                                <>
                                                    {(!paymentRequestData.isApproved && paymentRequestData?.currentUserId === user?.userId) ?
                                                        <span title="" onClick={() => deleteFundRequestItem(data)} >
                                                            <Icon icon="material-symbols:delete-outline-rounded" className='iconify-style'
                                                            />
                                                        </span>
                                                        :
                                                        <span title="" >
                                                            <Icon icon="material-symbols:delete-outline-rounded" className='iconify-style'
                                                                style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                            />
                                                        </span>
                                                    }
                                                </>
                                            )
                                        }}
                                    /> */}
                                    <Column dataField="itemSerialNo" caption="Sr no." allowEditing={false} />
                                    <Column dataField="vendorName" caption="Vendor" allowEditing={false} />
                                    <Column dataField="bankName" caption="Bank" allowEditing={false} />
                                    <Column
                                        dataField="balanceAmt"
                                        caption="Ledger Balance"
                                        allowEditing={false}
                                        cellRender={({ data }) => {
                                            const value = data.balanceAmt;
                                            return (
                                                <span>
                                                    {value === null || value === undefined
                                                        ? "-"
                                                        : `Rs. ${value.toLocaleString("en-IN")}`}
                                                </span>
                                            );
                                        }}
                                    />

                                    <Column
                                        dataField="recommendedAmt"
                                        caption="Recommended Amt."
                                        allowEditing={false}
                                        cellRender={({ data }) => {
                                            const value = data.recommendedAmt;
                                            return (
                                                <span>
                                                    {value === null || value === undefined
                                                        ? "-"
                                                        : `Rs. ${value.toLocaleString("en-IN")}`}
                                                </span>
                                            );
                                        }}
                                    />

                                    {/* Editable Payment Amount */}
                                    {
                                        !isEditAmt && <Column
                                            dataField="paidAmt"
                                            caption="Paid Amt"
                                            allowEditing={false}
                                            cellRender={({ data }) => {

                                                return (
                                                    <span>
                                                        Rs. {data.paidAmt.toLocaleString('en-IN')}
                                                    </span>
                                                );
                                            }}
                                        />
                                    }

                                    {isEditAmt && <Column
                                        dataField="paidAmt"
                                        caption="Payment Amt."
                                        dataType="number"
                                        format="#,##0.##"
                                        allowEditing={isEditAmt ? true : false}
                                        editorOptions={{
                                            min: 0,
                                            placeholder: "Enter amount",
                                        }}
                                        cellRender={({ data }) => {
                                            return (
                                                (data.paidAmt === 0 || data.paidAmt === null || data.paidAmt === undefined ? (
                                                    <span style={{ color: 'silver' }}>Enter amount</span>
                                                ) : (

                                                    <span style={{
                                                        color: '#333',
                                                        width: "100%",
                                                        border: "1px solid #cccef1",
                                                        borderRadius: "4px",
                                                        padding: "4px 6px",
                                                        textAlign: "right",
                                                        color: "#333",
                                                        fontWeight: "normal",
                                                        outline: "none",


                                                    }}>
                                                        Rs. {data.paidAmt.toLocaleString('en-IN')}
                                                    </span>
                                                ))
                                            );
                                        }}
                                    >
                                        {/* ✅ Validation Rules
                                        <RequiredRule message="Please enter payment amount" />
                                        <RangeRule
                                            min={1}
                                            message="Payment amount must be greater than 0"
                                        />
                                        <CustomRule
                                            validationCallback={(e) => {
                                                // Get current row data
                                                const { recommendedAmt } = e.data;
                                                // Return true if valid
                                                return e.value <= recommendedAmt;
                                            }}
                                            message="Payment amount cannot exceed Recommended Amt."
                                        /> */}
                                    </Column>}

                                     <Column dataField="advPaymentRequestId" caption="Advance Request ID" allowEditing={false}/>




                                    <Column dataField="remarks" caption="Remarks" visible={false} />
                                    {/* ✅ Summary Row for Totals */}
                                    <Summary>
                                        <TotalItem
                                            column="balanceAmt"
                                            summaryType="sum"
                                            customizeText={(e) =>
                                                e.value
                                                    ? `Rs. ${e.value.toLocaleString("en-IN")}`
                                                    : "Rs. 0"
                                            }
                                        />
                                        <TotalItem
                                            column="recommendedAmt"
                                            summaryType="sum"
                                            customizeText={(e) =>
                                                e.value
                                                    ? `Rs. ${e.value.toLocaleString("en-IN")}`
                                                    : "Rs. 0"
                                            }
                                        />
                                        <TotalItem
                                            column="paidAmt"
                                            summaryType="sum"
                                            customizeText={(e) =>
                                                e.value
                                                    ? `Rs. ${e.value.toLocaleString("en-IN")}`
                                                    : "Rs. 0"
                                            }
                                        />
                                    </Summary>

                                </DataGrid>
                                <div className="row mt-4">
                                    {paymentRequestData?.actionDetails?.map((stage, index) => (
                                        <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                                            <div className="w-100">
                                                <label className="form-label">{stage?.status} By,</label>
                                                {stage?.approvers?.map((approver, i) => (
                                                    <input
                                                        key={i}
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={`${approver?.firstName + " " + approver?.lastName} (${approver?.designation})`}
                                                        readOnly
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 reviews'>
                        <div className='card' >
                            <div className='card-body'>
                                <div className='mb-1 sub-title-color'>REMARKS</div>
                                <div class="list-group">
                                    {paymentRequestData?.history?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="list-group-item list-group-item-action flex-column align-items-start" style={{ borderBottom: '1px solid #cfcfcf', marginBottom: '0.5rem', paddingBottom: '0.5rem' }}
                                        >
                                            <div className='small mb-1' style={{ color: '#282c7d', fontWeight: '500' }}>
                                                {item.approvalStatusName === 'Recall' ? "Recall Requested" : item.approvalStatusName} by {item.userFirstName + " " + item.userLastName}
                                            </div>
                                            <div className="d-flex w-100 justify-content-between align-items-center">
                                                <small>Message</small>
                                                <small>
                                                    {item.updatedOn
                                                        ? new Date(item.updatedOn).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        }) +
                                                        ' ' +
                                                        new Date(item.updatedOn).toLocaleTimeString('en-GB', {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : ''}
                                                </small>
                                            </div>
                                            <div className="small" style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>{item?.remark}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* Attachments */}
                        {prAttachmentData?.length === 0 ? "" :
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='mb-1 sub-title-color'>ATTACHMENTS</div>
                                    {prAttachmentData?.map((item, index) => (
                                        <div class="list-group">
                                            <div
                                                key={index}
                                                className='list-group-item list-group-item-action flex-column align-items-start' style={{ borderBottom: '1px solid #cfcfcf', marginBottom: '0.5rem', paddingBottom: '0.5rem' }}>
                                                <div class="d-flex w-100 justify-content-between align-items-center">
                                                    <small
                                                        style={{ cursor: 'pointer', color: 'blue' }}

                                                        onClick={() => {
                                                            const fileUrl =
                                                                process.env.REACT_APP_CDN_VISHWAM_BASE_URL +
                                                                item?.filePath;
                                                            window.open(fileUrl, '_blank');
                                                        }}
                                                    >
                                                        {item?.fileName}
                                                        {/* item?.fileType */}
                                                    </small>
                                                    <small>{item?.fileSize} kb</small></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className='web-page-footer'>
                    www.vishwasamudra.in
                </div>
            </div>
            {/* Approval PopUp */}
            <Popup
                visible={isModalVisible}
                onHiding={() => setIsModalVisible(false)}
                showTitle={true}
                title="Approval"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <TextArea
                            value={remarks}
                            onInput={(e) => handleAproveRemarksChange(e)}
                            height={90}
                            placeholder="Type your remarks..."
                            maxLength={300}
                        />
                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                            {charCount}/300 characters
                        </div>
                        {error.remarks && (
                            <div style={{ color: "red" }}>{error.remarks}</div>
                        )}
                    </div>

                </div>
                <div className='text-right'>

                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleApproveSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {/* Reject PopUp */}
            <Popup
                visible={isRejectModalVisible}
                onHiding={() => setIsRejectModalVisible(false)}
                dragEnabled={false}
                showTitle={true}
                title="Back to Draft"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Sent to <span className="text-danger">*</span></label>
                        <div>
                            <SelectBox
                                dataSource={paymentRequestData?.actionDetails?.find(f => f.stageIndex === 1)?.approvers}
                                valueExpr="userId"
                                displayExpr={(item) =>
                                    item ? `${item?.firstName} ${item?.lastName} (${item?.designation})` : ""
                                }
                                className="form-control"
                                placeholder="Select user"
                                searchEnabled
                                disabled={true}
                                showClearButton={true}
                                value={paymentRequestData?.createdByUserId}
                            // onValueChanged={(e) => {
                            //     setUserIdForRejectIOM(e.value);
                            // }}
                            //onValueChanged={(e) => handleUserRejectChange(e)}
                            />
                            {error.userIdForRejectIOM && (
                                <div style={{ color: "red" }}>{error.userIdForRejectIOM}</div>
                            )}
                        </div>
                    </div>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <div>
                            <TextArea
                                value={remarks}
                                onInput={(e) => handleRejectRemarksChange(e)}
                                height={90}
                                placeholder="Type your remarks..."
                                maxLength={300}
                            />
                            <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                                {charCount}/300 characters
                            </div>
                            {error.remarks && (
                                <div style={{ color: "red" }}>{error.remarks}</div>
                            )}
                        </div>
                    </div>


                </div>
                <div className='text-right'>
                    <Button icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsRejectModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleRejectSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {loading && <Loader loadingMessage={""} />}
        </Fragment>
    )
}
